import React, { Component } from 'react'
import style from './style.module.less'
import { Steps, Modal, Input } from 'hljd'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import moment from 'moment'
import {
  FRANCHISE_STATUS_PASSED,
  FRANCHISE_STATUS_NOT_FOLLOW
} from '../../constant'

const Step = Steps.Step
const TextArea = Input.TextArea

@observer
class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      des: ''
    }
  }
  handleOk = () => {
    this.props.store.finish(this.state.des)
    this.handleCancel()
  }
  handleCancel = () => {
    this.setState({
      visible: false,
      des: ''
    })
  }
  render() {
    const { visible, des } = this.state
    const { store } = this.props
    const detailData = toJS(store.detailData)
    const { franchise_status = '0' } = detailData
    const statusFn = value => {
      if (
        franchise_status == FRANCHISE_STATUS_PASSED ||
        franchise_status == FRANCHISE_STATUS_NOT_FOLLOW
      ) {
        return 'wait'
      }

      if (franchise_status < value) {
        return 'wait'
      } else if (franchise_status == value) {
        return 'process'
      } else {
        return 'finish'
      }
    }
    return (
      <div className={style['setp-wrap']}>
        {franchise_status == 3 && (
          <div className="finish-box">
            <div className="content-wrap clearfix">
              <span className="fl">是否已完成服务?</span>
              <span
                className="fr"
                onClick={() => this.setState({ visible: true })}
              >
                确认完成
              </span>
            </div>
          </div>
        )}

        {franchise_status == FRANCHISE_STATUS_PASSED && (
          <div className="over-time" />
        )}
        {franchise_status == FRANCHISE_STATUS_NOT_FOLLOW && (
          <div className="not-follow" />
        )}
        <Steps className={style.step}>
          <Step
            status={statusFn('1')}
            title="沟通"
            icon={<span className="num-icon">1</span>}
          />
          <Step
            status={statusFn('2')}
            title="到店"
            icon={<span className="num-icon">2</span>}
          />
          <Step
            status={statusFn('3')}
            title="签单"
            icon={<span className="num-icon">3</span>}
          />
          <Step
            status={statusFn('4')}
            title="完成服务"
            icon={<span className="num-icon">4</span>}
          />
        </Steps>
        {detailData.arrive_at && (
          <div className="arrive-at-box">
            预约到店：{moment(detailData.arrive_at).format('YYYY-MM-DD')}
          </div>
        )}
        <Modal
          title="确认完成服务"
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={400}
        >
          <TextArea
            rows={3}
            value={des}
            onChange={e => this.setState({ des: e.target.value })}
            placeholder="请填写服务中出现的问题、用户满意情况等信息"
          />
        </Modal>
      </div>
    )
  }
}

export default index
